import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../ui/Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-390">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 pointer-events-none" data-id="element-391">
          <div className="max-w-4xl mx-auto bg-white border border-slate-200 shadow-soft-lg p-4 rounded-2xl flex flex-col sm:flex-row items-center justify-between gap-4 pointer-events-auto" data-id="element-392">
            <div className="hidden sm:block" data-id="element-393">
              <div className="text-slate-900 font-display font-bold text-lg" data-id="element-394">
                The 2026 Beginner's Guide to Cheap Homes
              </div>
              <div className="text-orange-600 text-sm font-bold tracking-wide mt-1" data-id="element-395">
                Just $6.36
              </div>
            </div>

            <Button className="w-full sm:w-auto py-3 px-6 text-base" onClick={e => {
          e.preventDefault();
          document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-396">
              Get My First House 50% Off
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}